<template lang="html">
  <div class="shopify-remove-channel">
    <Guide
      :content="content"
      contentHeading="Sign up complete!"
      :contentVideo="contentVideo"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'ShopifyCompleteAccount',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'shopify-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'shopify-create-app',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'remove-sales-channel',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>Congratulations, you have successfully created a Shopify account and removed the Online Store sales channel.</p>

          <p>The next step is connecting your new Shopify account to our platform so customers can browse and purchase your products through your website.</p>

          <hr>

          <p>There are <strong>3 simple steps</strong> to follow.</p>
        `
    },

    contentVideo() {
      return 'https://page-maker-pro.s3.eu-west-2.amazonaws.com/6+-+PIG_01.mp4'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
